import { render, staticRenderFns } from "./AutorizacaoVaga.vue?vue&type=template&id=022b7b15"
import script from "./AutorizacaoVaga.vue?vue&type=script&lang=js"
export * from "./AutorizacaoVaga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports